import { axiosInstance } from '../common/api';

export const createReimbursementRequest = (data) => {
  const url = `/reimbursement/`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getMyReimbursements = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);
  const queryString = params.toString();
  const url = `/reimbursement/my-reimbursements${queryString ? `?${queryString}` : ''}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllReimbursements = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.employeeName) params.append('employeeName', filters.employeeName);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
  if (filters.companyId) params.append('companyId', filters.companyId);
  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);
  const queryString = params.toString();
  const url = `/reimbursement/${queryString ? `?${queryString}` : ''}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getReimbursementById = (id) => {
  const url = `/reimbursement/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateReimbursementRequest = (id, data) => {
  const url = `/reimbursement/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateReimbursementStatus = (id, data) => {
  const url = `/reimbursement/${id}/status`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const cancelReimbursement = (id) => {
  const url = `/reimbursement/${id}/cancel`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getReviewers = (companyId = null) => {
  const params = new URLSearchParams();
  if (companyId) params.append('companyId', companyId);
  const queryString = params.toString();
  const url = `/reimbursement/reviewers${queryString ? `?${queryString}` : ''}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllCompanies = () => {
  const url = `/reimbursement/companies`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
